'use client';
import { motion } from 'framer-motion';
import { Button } from '@/components/button';

const transition = { duration: 1, ease: [0.25, 0.1, 0.25, 1] };
const variants = {
  hidden: { filter: 'blur(10px)', transform: 'translateY(20%)', opacity: 0 },
  visible: { filter: 'blur(0)', transform: 'translateY(0)', opacity: 1 },
};

const heroContent = [
  'San Diego, CA · Open to remote',
  // `I'm Raymond. I design and build for small teams that need to move like they have three.`
  //`I'm Raymond. I handle the branding, design, and code for small teams that want to punch three weight classes above their size.`,
  `I'm Ray — a product designer, frontend developer, and a founder's secret weapon.`,
  'Identity, product design and frontend development, From strategy to shipped code, for early-stage funded startups.',
];
const heroContentAlt = [
  'San Diego, CA · Open to remote',
  `I'm Ray — a product designer and frontend developer for small teams that need to move like they have three people.`,
  'I design brands and interfaces, then build them myself — Figma to shipped code — for early-stage, funded startups.',
];

const Hero: React.FC = () => {
  return (
    <section className="container my-10 lg:my-16">
      <motion.div
        initial="hidden"
        animate="visible"
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.15,
            },
          },
        }}>
        <motion.h2
          animate={transition}
          variants={variants}
          className="dark:text-ivory text-xs font-bold tracking-wider uppercase">
          San Diego, CA · Open to remote
        </motion.h2>

        <motion.div animate={transition} variants={variants}>
          <svg
            className="text-copper/30 dark:text-ivory/30 mt-2 mb-5 w-8 fill-current"
            viewBox="0 0 35 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M30.3659 11C33.4553 10.6667 35 9.04167 35 6.125C35 5.79167 34.9593 5.41667 34.878 5C34.4715 1.91667 32.6016 0.375003 29.2683 0.375003C28.7805 0.375003 28.2114 0.416669 27.561 0.500001L8.29268 3.125C8.04878 3.125 7.80488 3.125 7.56098 3.125C5.85366 3.125 4.8374 2.08333 4.51219 0C2.96748 0.0833347 1.82927 0.625002 1.09756 1.625C0.365852 2.625 0 3.54167 0 4.375C0 8.54167 1.91057 10.625 5.73171 10.625C6.21951 10.625 6.78862 10.5833 7.43903 10.5L26.5854 7.75C26.8293 7.75 27.0732 7.75 27.3171 7.75C28.9431 7.75 29.9593 8.83333 30.3659 11Z" />
          </svg>
        </motion.div>

        <motion.h1
          variants={{
            hidden: { opacity: 0, y: 25, filter: 'blur(10px)' },
            visible: { opacity: 1, y: 0, filter: 'blur(0)' },
          }}
          transition={{
            duration: 1,
            ease: [0.22, 1, 0.36, 1],
          }}
          className="dark:text-copper relative max-w-3xl font-serif text-4xl leading-tight tracking-tight">
          I'm Raymond Lopez, a front-end developer &amp; product designer,
          driven by guitar riffs.
        </motion.h1>
      </motion.div>
    </section>
  );
};

export default Hero;
